import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCTW29vPIkmjA2q2KsxP-GU_dI-jC30bVI",
  authDomain: "rockthrowers-3900.firebaseapp.com",
  projectId: "rockthrowers-3900",
  storageBucket: "rockthrowers-3900.appspot.com",
  messagingSenderId: "1072339286093",
  appId: "1:1072339286093:web:c8d2c3d0677a593c25c404",
  measurementId: "G-XB54ZGSW4Y"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const storage = getStorage(app)